import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import logo from "../../../assets/logo.png";
import clgImg from "../../../assets/college-2.jpeg";
import clgImg1 from "../../../assets/college-1.jpeg";
import clgImg2 from "../../../assets/college-3.jpeg";
import clgImg3 from "../../../assets/college-4.jpeg";
import { Carousel } from 'react-responsive-carousel';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { options } from './MenuOptions';

const HomePageHeader = ({ isHome }) => {
    const history = useHistory();
    const [userMenu, toggleUserMenu] = useState(false);
    const [moreMenu, toggleMoreMenu] = useState(false);
    const [cursorIn, setCursorIn] = useState({});
    const [viewList, setViewList] = useState({});
    const [hamburgerMenu, toggleHamburger] = useState(false);

    const onClickMoreMenu = (val) => {
        if (!val) {
            setViewList({});
        }
        toggleUserMenu(false);
        toggleMoreMenu(val);
    };

    const onCliUserMenu = (val) => {
        toggleMoreMenu(false);
        setViewList({});
        setCursorIn({});
        toggleUserMenu(val);
    };

    const toggleViewList = (idx) => {
        if (viewList[idx]) {
            setViewList({});
        } else {
            setViewList({ [idx]: true });
        }
    };

    const onClickHamburger = (val) => {
        onClickMoreMenu(val);
        toggleHamburger(val);
    };

    const renderOptions = (options = []) => {
        return (
            <>
                {options.map((op = {}, idx) => {
                    const { label = '', navigateTo = '', childOptions = [] } = op;
                    if (childOptions.length) {
                        return (
                            <div key={idx} style={{ position: 'relative' }}>
                                <li
                                    onMouseEnter={() => setCursorIn({ [idx]: true })}
                                    onMouseLeave={() => setCursorIn({})}
                                    onClick={() => toggleViewList(idx)}
                                >
                                    <p style={(cursorIn[idx] || viewList[idx]) && { fontWeight: 'bold' }} >{label}</p>
                                    {(cursorIn[idx] || viewList[idx]) && <i className="fa fa-caret-right" aria-hidden="true"></i>}
                                </li>
                                {viewList[idx] && (
                                    <div className='inner-list'>
                                        {childOptions.map((chOp = {}, idxx) => {
                                            const { chLabel = '', navigateTo = '' } = chOp;
                                            return <li key={idxx} onClick={() => history.push(navigateTo)}>{chLabel}</li>
                                        })}
                                    </div>)
                                }
                            </div>
                        )
                    }
                    return <li key={idx}><p onClick={() => history.push(navigateTo)}>{label}</p></li>
                })}
            </>
        );
    };

    const renderUserLogin = () => {
        return (
            <div style={{ position: 'relative' }}>
                <i className="fa fa-user-circle-o ml-2" aria-hidden="true" onClick={() => onCliUserMenu(!userMenu)} style={{cursor: 'pointer'}}></i>
                <div className={`user-tooltip ${userMenu ? 'show' : ''}`}>
                    <div
                        className="one"
                        style={{ borderBottom: '1px solid #d4d2d2' }}
                        onClick={() => history.push("/login")}
                    >
                        Student Login
                    </div>
                    <div
                        className="two"
                        onClick={() => history.push("/login")}
                    >
                        College Login
                    </div>
                </div>
            </div>
        );
    };

    return (
        <div className="nav-container container">
            <nav className="navbar navbar-light w-100" style={{ height: "82px" }}>
                <img alt="logo" src={logo} height="50px" width="245px" onClick={() => history.push("/home")} style={{ cursor: 'pointer' }} />
                <nav className="links">
                    <ul className="d-flex justify-content-between align-items-center nav-links m-0">
                        <li><a href="#" onClick={() => history.push("/home")}>Home</a></li>
                        {isHome && <li><a href="#gallery">Gallery</a></li>}
                        {isHome && <li><a href="#contact">Contact Us</a></li>}
                        {isHome && <li><a href="#news">News</a></li>}
                        <li><a href="#" className={`${moreMenu ? 'selected' : ''}`} onClick={() => onClickMoreMenu(!moreMenu)}>Menu</a></li>
                        {renderUserLogin()}
                    </ul>
                </nav>
                <div className='min-res'>
                    {renderUserLogin()}
                    <div className={`icon nav-icon-5 ${hamburgerMenu ? 'open' : ''}`} onClick={() => onClickHamburger(!hamburgerMenu)}>
                        <span></span>
                        <span></span>
                        <span></span>
                    </div>
                </div>
            </nav>
            <div className={`more-menu ${moreMenu ? 'show' : ''}`} style={{ boxShadow: "0 3px 10px rgb(0 0 0 / 0.2)" }}>
                <div className="d-flex">
                    <div className="row w-100 pt-3">
                        <div className="col-md-6 d-flex">
                            <ul>
                                {renderOptions(options)}
                            </ul>
                        </div>
                        <div className="col-md-6 mt-5 nav-carousel">
                            <Carousel autoPlay infiniteLoop showThumbs={false}>
                                <div>
                                    <img src={clgImg} alt='image' />
                                </div>
                                <div>
                                    <img src={clgImg1} alt='image' />
                                </div>
                                <div>
                                    <img src={clgImg2} alt='image' />
                                </div>
                                <div>
                                    <img src={clgImg3} alt='image' />
                                </div>
                            </Carousel>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HomePageHeader